const HEXBIN160 = 40;

export const calcSfdiFromLfdi = lfdi => {
  let i;
  let lastDigit;
  // Make sure the LFDI is the full 40 characters. If not, add leading 0s
  lfdi = '0'.repeat(HEXBIN160 - lfdi.length).concat(lfdi);
  // Generate SFDI from first 9 bytes of LFDI
  const sfdiStr = lfdi.substring(0, 9);
  // Turn it into a number
  const sfdi = parseInt(sfdiStr, 16);
  // Turn it back into a string (decimal)
  const sfdiDec = sfdi.toString(10);
  // Calculate final 12th digit of SFDI such that
  // the sum of all 12 digits equals 0 mod 10.
  let digit;
  let digitStr;
  let sum = 0;
  for (i = 0; i < sfdiDec.length; i++) {
    digitStr = sfdiDec.substring(i, i + 1);
    digit = parseInt(digitStr, 10);
    sum += digit;
  }
  const mod = sum % 10;
  if (mod === 0) {
    lastDigit = 0;
  } else {
    lastDigit = 10 - mod;
  }
  return sfdiDec.concat(lastDigit.toString(10));
};
